import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import {
  getClientType,
  createClientType,
  updateClientType,
  deleteClientType,
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
  getClientTypeById,
} from "../../../store/slices/clientTypeSlice";
import Table from "../../common/Table/table";
import AddUpdateClientType from "./AddUpdateClientType";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const ClientType = () => {
  const dispatch = useDispatch();
  const {
    clientTypes,
    createClientTypeSuccessMessage,
    createClientTypeErrorMessage,
    updateClientTypeSuccessMessage,
    updateClientTypeErrorMessage,
    deleteClientTypeSuccessMessage,
    deleteClientTypeErrorMessage,
    searchMessage,
    clientTypeInfo,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.clientType);

  const { userInfo, token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const [showStatus, setShowStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [showModal, setModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);

  const clinicId =clinicInfo?.[0]?.clinicId;
  const initialState = {
    id: "",
    clinicId: "",
    createdBy: "",
    name: "",
    status: "Active",
  };
  const [formData, setFormData] = useState(initialState);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  const [inputError, setInputError] = useState({
    name: false,
  });
  const title = [
    { title: "Name", key: "name" },
    { title: "Status", key: "status" },
  ];

  const fetchClientType = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getClientType({
            clinicId,
            status: tableStatus,
            token,
            currentPage: page,
            limit: lim,
            name: search || undefined,
          })
        );
      }
    },
    [clinicId, token, dispatch, tableStatus, searchValue, pageLimit]
  );

  useEffect(() => {
    fetchClientType();
  }, [fetchClientType, showModal, showDeleteModal, showGlobalViewModal]);

    const handlePageChange = (page) => {
    fetchClientType(page, pageLimit, searchValue);
  };
 const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);              
    fetchClientType(1, newLimit, searchValue); 
  };

  useEffect(() => {
    showTostifyMessageAndReset(
      createClientTypeSuccessMessage,
      showToastifySuccess,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      createClientTypeErrorMessage,
      showToastifyError,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      updateClientTypeSuccessMessage,
      showToastifySuccess,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      updateClientTypeErrorMessage,
      showToastifyError,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      deleteClientTypeSuccessMessage,
      showToastifySuccess,
      resetDeleteMessages
    );
    showTostifyMessageAndReset(
      deleteClientTypeErrorMessage,
      showToastifyError,
      resetDeleteMessages
    );
  }, [
    createClientTypeSuccessMessage,
    createClientTypeErrorMessage,
    updateClientTypeSuccessMessage,
    updateClientTypeErrorMessage,
    deleteClientTypeSuccessMessage,
    deleteClientTypeErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const tableHead = [
    { title: "Name", key: "name" },
    { title: "Status", key: "status" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleModal = () => {
    setFormData(initialState);
    setModalVisible(true);
    setModalAction("create");
  };
  const handleEdit = (item) => {
    setFormData({
      id: item?.id,
      name: item?.name,
      status: item?.status,
    });
    setModalVisible(true);
    setModalAction("edit");
  };

  const handleAddOrUpdateClientType = async (e) => {
    e.preventDefault();
    if (inputError.name) {
      return;
    }
    try {
      if (modalAction === "create") {
        await dispatch(
          createClientType({
            ...formData,
            clinicId,
            createdBy: userInfo._id,
            token,
          })
        );
      } else {
        await dispatch(
          updateClientType({
            ...formData,
            clinicId,
            updatedBy: userInfo._id,
            token,
          })
        );
      }
      fetchClientType();
      setModalVisible(false);
      setFormData(initialState);
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleDelete = (item) => {
    setFormData({
      id: item?.id,
      name: item?.name,
      status: item?.status,
    });
    setDeleteModalVisible(true);
  };

  const handleDeleteClientType = async () => {
    try {
      await dispatch(
        deleteClientType({
          id: formData?.id,
          clinicId,
          token,
        })
      );

      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error occurred while deleting client type:", error);
    }
  };

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchClientType(1, pageLimit, value);
    },
    [fetchClientType, pageLimit]
  );

  const handleUpdateStatus = async (status, item) => {
    try {
      const updatedData = {
        id: item?.id,
        name: item?.name,
        status,
        clinicId,
        updatedBy: userInfo?._id,
      };
      await dispatch(updateClientType({ ...updatedData, token }));
      fetchClientType();
    } catch (error) {
      console.error("Error updating client status:", error);
    }
  };

  const handleShowGlobalViewModal = async (data) => {
    await dispatch(getClientTypeById({ id: data.id, token }));
    setShowGlobalViewModal(true);
  };
  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          clientTypes &&
          clientTypes?.map((item) => ({
            id: item?._id,
            name: item?.name,
            status: item?.status,
            clinicId: item?.clinicId,
            createdBy: item?.createdBy,
          }))
        }
        addModal={handleModal}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        searchValue={searchValue}
        handleSearch={handleSearch}
        errorMessage={searchMessage}
        handleAddBtn={true}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />

      <AddUpdateClientType
        showModal={showModal}
        setModalVisible={setModalVisible}
        formData={formData}
        handleChange={handleChange}
        modalAction={modalAction}
        handleAddOrUpdateClientType={handleAddOrUpdateClientType}
        setInputError={setInputError}
      />

      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Delete Client Type</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          Are you sure you want to delete the client type:{" "}
          <strong>{formData?.name}</strong>?
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeleteClientType}
          >
            Delete
          </button>
        </div>
      </Modal>

      {/* View Modal */}
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"md"}
        titel={title && title}
        content={{
          name: clientTypeInfo?.list?.name,
          status: clientTypeInfo?.list?.status,
        }}
      />
    </div>
  );
};

export default ClientType;
